export const types = {
    GET_PREMIUM_USERS_REQUEST: 'GET_PREMIUM_USERS_REQUEST',
    GET_PREMIUM_USERS_SUCCESS: 'GET_PREMIUM_USERS_SUCCESS',
    GET_PREMIUM_USERS_FAILURE: 'GET_PREMIUM_USERS_FAILURE'
}